import React from 'react';
import './index.less';

import PayoutDefaultTH from './components/payout-default-th';
import PayoutSortingTH from './components/payout-sorting-th';
import { getCurrencyIcon } from '../../../../../../../../shared/js/get-currency-icon';

import PayoutIsUrgentIcon from '../components/payout-is-urgent-icon';

function PayoutHead({ sorting, sort, payoutSystem, isToPayColumnShouldBeShown }) {
	const payout_fee = Number(payoutSystem.payout_fee);
	return (
		<thead className='payout-table--head new-table__head font-roboto-medium'>
			<tr>
				<PayoutDefaultTH
					className='min-width'
				/>
				<PayoutSortingTH
					className='min-width'
					index='is_urgent'
					sorting={sorting}
					sort={sort}
					isSortIconVisible={false}
				>
					<PayoutIsUrgentIcon
						active={sorting.index === 'is_urgent' ? sorting.direction === 'desc' : undefined}
					/>
				</PayoutSortingTH>
				<PayoutSortingTH
					className='min-width'
					index='date'
					sorting={sorting}
					sort={sort}
				>
					Date
				</PayoutSortingTH>
				<PayoutSortingTH
					className='min-width'
					index='status'
					sorting={sorting}
					sort={sort}
				>
					Status
				</PayoutSortingTH>
				<PayoutSortingTH
					className='width-affiliate text-align-left'
					index='affiliate'
					sorting={sorting}
					sort={sort}
				>
					Affiliate
				</PayoutSortingTH>
				<PayoutSortingTH
					className='width-amount text-align-right'
					index='amount'
					sorting={sorting}
					sort={sort}
				>
					Amount
				</PayoutSortingTH>
				{isToPayColumnShouldBeShown && (
					<PayoutSortingTH
						className='width-amount text-align-right'
						index='amount_to_pay'
						sorting={sorting}
						sort={sort}
					>
						<span className='payout-table--head--percent'>
							{
								payout_fee
									? `${payout_fee} ${getCurrencyIcon(payoutSystem.currency)}`
									: `${Number(payoutSystem.payout_percent)}%`
							}
						</span> To pay
					</PayoutSortingTH>
				)}
				<PayoutDefaultTH>
					Credentials
				</PayoutDefaultTH>
				<PayoutSortingTH
					className='min-width'
					index='paid_at'
					sorting={sorting}
					sort={sort}
				>
					Paid at
				</PayoutSortingTH>
				<PayoutSortingTH
					className='text-align-right'
					index='paid'
					sorting={sorting}
					sort={sort}
				>
					Paid
				</PayoutSortingTH>
				<PayoutDefaultTH
					className='text-align-right'
				>
					App
				</PayoutDefaultTH>
				<PayoutDefaultTH
					className='min-width text-align-left'
				>
					Actions
				</PayoutDefaultTH>
			</tr>
		</thead>
	);
}

export default PayoutHead;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-head/index.js